import React from 'react';

import Modal from 'antd/lib/modal';
import vdfmlogo from 'static/img/VDFM_small.png';
import FeesDocument from '../../dashboard/GDPR/FeesDocument';
import { I18n as I } from 'react-redux-i18n';

import { Typography, Tabs } from 'antd';

const { Paragraph, Title } = Typography;
const { TabPane } = Tabs;

const InfoModal = ({ visible, closeModal }) => {
  return (
    <Modal
      visible={visible}
      //   width={`calc(100vw - 500px)`}
      width={800}
      onCancel={() => closeModal('Info')}
      title={
        <div>
          <img src={vdfmlogo} alt="vdfmlogo" className="logo-default" />
          <span style={{ fontSize: 24 }}>E-Salvage Info</span>
        </div>
      }
      footer={[null]}
    >
      <Tabs defaultActiveKey="1" style={{ marginBottom: 10 }}>
        <TabPane tab={'Δημοπρασίες'} key="1">
          <div style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
            <Title level={4}>Δημοπρασίες</Title>
            <Paragraph>
              Για να λάβετε μέρος στις δημοπρασίες οχημάτων που γίνονται
              καθημερινά στην πλατφόρμα του <strong>E-Salvage</strong> το μόνο
              που χρειάζεται είναι να δώσετε την προσφορά σας. Εφόσον
              ολοκληρωθεί η δημοπρασία, οι προσφορές εμφανίζονται στην
              ασφαλιστική εταιρεία που δημοπρατεί το όχημα και επιλέγει την
              καλύτερη. Με την επιλογή της προσφοράς κάποιου εμπόρου, το όχημα
              δεσμεύεται προς αγορά από τον έμπορο για 18 ημέρες. Μετά το πέρας
              της προθεσμίας η ασφαλιστική εταιρεία έχει την δυνατότητα επιλογής
              άλλης προσφοράς.
            </Paragraph>
          </div>
          <div style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
            <Title level={4}>
              Δημοπρασίες
              <span
                style={{
                  marginLeft: 10,
                  padding: 2,
                  borderRadius: '5px 5px 5px',
                  border: '2px solid #e82727',
                  color: '#e82727',
                  fontWeight: 600,
                }}
              >
                LIVE
              </span>
            </Title>
            <Paragraph>
              Οι <strong>LIVE</strong> δημοπρασίες λειτουργούν όπως ακριβώς και
              οι απλές μέχρι την λήξη του αρχικού τους χρόνου. Εφόσον
              ολοκληρωθεί το 1ο σκέλος της δημοπρασίας, στους εμπόρους με τις 3
              καλύτερες προσφορές προστίθoνται άλλα 15 λεπτά για προσφορές. Σε
              αυτά τα 15 λεπτά, είναι διακριτό και στους 3 εμπόρους το ποσό της
              καλύτερης προσφοράς ώστε να μπορούν να δίνεται η δυνατότητα να
              κάνουν καλύτερη προσφορά. Στα τελευταία 2 λεπτά, όποτε δίνεται
              κάποια νέα μεγαλύτερη προσφορά ο χρόνος αυξάνεται κατα 30
              δευτερόλεπτα.
            </Paragraph>
          </div>
        </TabPane>
        <TabPane tab={`${I.t('FEES')}`} key="2">
          <FeesDocument showApproveButton={false} showCheckBox={false} />
        </TabPane>
      </Tabs>
    </Modal>
  );
};

export default InfoModal;
